// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"09859439","115":"24a1e249","237":"20fa3443","341":"b3282d35","474":"6a96c469","493":"493ab1c0","795":"aeb22c82","856":"52ab3b01"}[chunkId] + ".chunk.js";
};